import { render, staticRenderFns } from "./PageRiskAssessment.vue?vue&type=template&id=6ed5859a&scoped=true&"
import script from "./PageRiskAssessment.vue?vue&type=script&lang=js&"
export * from "./PageRiskAssessment.vue?vue&type=script&lang=js&"
import style0 from "./PageRiskAssessment.vue?vue&type=style&index=0&id=6ed5859a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed5859a",
  null
  
)

export default component.exports